import { render, staticRenderFns } from "./ProjectCardPopup.vue?vue&type=template&id=db36f8d0&scoped=true&"
import script from "./ProjectCardPopup.vue?vue&type=script&lang=js&"
export * from "./ProjectCardPopup.vue?vue&type=script&lang=js&"
import style0 from "./ProjectCardPopup.vue?vue&type=style&index=0&id=db36f8d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db36f8d0",
  null
  
)

export default component.exports